function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0f70"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0f70"] = parcelRequire;
}
parcelRequire.register("ji6vK", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $e0b4bfb7756ed42b$export$6503ec6e8aabbaf; }, function (v) { return $e0b4bfb7756ed42b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $e0b4bfb7756ed42b$export$f7ad0328861e2f03; }, function (v) { return $e0b4bfb7756ed42b$export$f7ad0328861e2f03 = v; });
var $e0b4bfb7756ed42b$export$6503ec6e8aabbaf;
var $e0b4bfb7756ed42b$export$f7ad0328861e2f03;
"use strict";
var $e0b4bfb7756ed42b$var$mapping = {};
function $e0b4bfb7756ed42b$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$e0b4bfb7756ed42b$var$mapping[keys[i]] = pairs[keys[i]];
}
function $e0b4bfb7756ed42b$var$resolve(id) {
    var resolved = $e0b4bfb7756ed42b$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$e0b4bfb7756ed42b$export$6503ec6e8aabbaf = $e0b4bfb7756ed42b$var$register;
$e0b4bfb7756ed42b$export$f7ad0328861e2f03 = $e0b4bfb7756ed42b$var$resolve;

});

var $ae45205983094866$exports = {};

(parcelRequire("ji6vK")).register(JSON.parse('{"6l7UR":"index.7dbd827c.js","4tGuq":"api.b4981d20.js","c2yYl":"graphite_wasm_bg.f6ff7329.wasm","fs6JN":"thumbnail-just-a-potted-cactus.0c1da70d.png","f0UtT":"thumbnail-valley-of-spires.13f0179f.png","lHCYc":"index.ee2897e9.css"}'));


//# sourceMappingURL=index.5891a348.js.map
